import { render } from "./field_settings.vue?vue&type=template&id=456ded76"
import script from "./field_settings.vue?vue&type=script&lang=js"
export * from "./field_settings.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__